/**
 * @fileoverview Configuration file for the storyteller package
 *
 * @example
 * // Usage:
 * import config from './config'
 *
 * // Access config values
 * const iceServerURL = config.webRTC.urls.ice
 * const staticFile = config.s3.getStaticURL('image.jpg')
 */


/**
 * @interface Config
 * @description The configuration object for the storyteller package
 */
export interface Config {
    defaultLanguage: string
    webRTC: {
        urls: Record<'sessions' | 'recordings' | 'ice', string>
    }
    s3: {
        buckets: Record<'static', string>
        getStaticURL(file: string): string
    }
    featureFlags: {
        url: string
    }
}

/**
 * @function getStaticURL
 * @description Gets the static URL for a file
 * @param {string} file - The file to get the URL for
 * @returns {string} The static URL for the file
 */
function getStaticURL(file: string) {
    return config.s3.buckets.static + '/' + file
}

const config: Config = {
    defaultLanguage: 'en-US',
    webRTC: {
        urls: {
            ice: `${process.env.WEBRTC_HOST}/iceServers`,
            sessions: `${process.env.WEBRTC_HOST}/sessions`,
            recordings: `${process.env.WEBRTC_HOST}/recordings`,
        },
    },
    featureFlags: {
        url: `${process.env.API_HOST}/featureFlags/`,
    },
    s3: {
        buckets: {
            static: 'https://novoic-static.s3.us-west-2.amazonaws.com',
        },
        getStaticURL,
    },
}

export default config
